(() => {
  'use strict';
  // Delegate to the existing Shrine serializer: it preserves bundle variants,
  // quantities, properties, selling plans and the existing cart session.
  // Capture prevents the legacy global SectionAtcBtn listener from firing twice.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-morii-checkout]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form');
    const addButton = form?.querySelector('[name="add"]');
    if (!productForm || !form || !addButton || button.disabled) return;
    if (addButton.getAttribute('aria-disabled') === 'true') return;
    const showError = (key) => {
      const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
      const message = wrapper?.querySelector('.product-form__error-message');
      if (message) message.textContent = productForm.dataset[key];
      if (wrapper) wrapper.hidden = false;
    };
    if (typeof productForm.handleSubmit !== 'function') {
      showError('checkoutUnavailable');
      return;
    }
    if (addButton.disabled || addButton.dataset.unavailable === 'true' ||
        Number(addButton.dataset.requiredFields || 0) > Number(addButton.dataset.validFields || 0)) {
      showError('checkoutSelection');
      return;
    }
    if (!form.reportValidity()) return;
    // Do not bypass a required cart terms step if the merchant enables one.
    const terms = document.querySelector('tnc-chekcbox[data-disable-button="true"]');
    const requiresCart = terms && terms.dataset.checked !== 'true';
    if (requiresCart && productForm.skipCart) {
      showError('checkoutSelection');
      productForm.cart?.open?.();
      return;
    }
    productForm.handleSubmit({
      currentTarget: requiresCart ? form : button,
      preventDefault() {}
    });
  }, true);
})();
